import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Select, { Creatable } from 'react-select';
import cx from 'classnames';

import { ChevronDownIcon } from '@snapask/common-components';

import styles from './OutlineSelect.scss';

class OutlineSelect extends Component {
  static propTypes = {
    onChange: PropTypes.func.isRequired,
    arrowRenderer: PropTypes.func,
    creatable: PropTypes.bool,
    error: PropTypes.string,
    floatingLabelText: PropTypes.string,
    options: PropTypes.array,
    placeholder: PropTypes.string,
  };

  static defaultProps = {
    arrowRenderer: ({ isOpen }) => (
      <div className={cx(styles.arrowIcon, { [styles.arrowIconOpen]: isOpen })}>
        <ChevronDownIcon width={24} height={24} />
      </div>
    ),
    creatable: false,
    placeholder: '',
    error: '',
    onChange: () => {},
    floatingLabelText: '',
    options: [],
  };

  state = {};

  render() {
    const {
      floatingLabelText,
      options,
      onChange,
      placeholder,
      creatable,
      arrowRenderer,
      error,
      ...args
    } = this.props;

    return (
      <div className={cx(styles.root, { [styles.hasError]: error })}>
        {floatingLabelText && <label>{floatingLabelText}</label>}
        {creatable ? (
          <Creatable
            arrowRenderer={arrowRenderer}
            placeholder={placeholder}
            options={options}
            onChange={onChange}
            {...args}
          />
        ) : (
          <Select
            arrowRenderer={arrowRenderer}
            placeholder={placeholder}
            options={options}
            onChange={onChange}
            {...args}
          />
        )}
        {error && <small className={styles.errorText}>{error}</small>}
      </div>
    );
  }
}

export default OutlineSelect;



// WEBPACK FOOTER //
// ./app/components/fields/OutlineSelect/OutlineSelect.jsx